import ResourceTyped from './ResourceTyped';

export type AgentPageStatus = 'draft' | 'active' | 'disabled';

// Where a published page surfaces, chosen at creation (WEB-6978).
export type AgentPagePlacement = 'standalone' | 'clientCard' | 'orderModal';

export type PreviousVersion = {
	version: number;
	source: string;
	compiledBundle: string | null;
	savedAt: string;
	savedBy: number | null;
};

export type AgentPage = {
	id: number;
	name: string;
	slug: string;
	status: AgentPageStatus;
	placement: AgentPagePlacement;
	version: number;
	isInternalOnly: boolean;
	regDate: string;
	modDate: string;
	regBy: number | null;
	modBy: number | null;
	// Returned only by getOne (omitted from list payload for size)
	source?: string;
	previousVersions?: PreviousVersion[] | null;
};

class AgentPageResource extends ResourceTyped<AgentPage> {
	constructor() {
		super('agentPage');
	}
}
const resource = new AgentPageResource();
export default resource;
